import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=37a41b40&scoped=true"
import script from "./questions.vue?vue&type=script&lang=js"
export * from "./questions.vue?vue&type=script&lang=js"
import style0 from "./questions.vue?vue&type=style&index=0&id=37a41b40&prod&lang=scss&scoped=true"
import style1 from "./questions.vue?vue&type=style&index=1&id=37a41b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a41b40",
  null
  
)

export default component.exports